import React, { useEffect, useState } from "react";
import ToggleDetails from "./ToggleDetails";
import { useDispatch, useSelector } from "react-redux";
import Guide from "./Guide";
import Stepflow from "./Stepflow";
import Transaction from "./Transaction";

function Dashboard() {
  const Status = useSelector(
    (state) => state.statistics.GuideStatsToggleStatus
  );
  return (
    <>
      <div className="flex flex-col max-w-5xl mt-2 mb-5 xl:max-w-7xl">
        <div>
          <h2 className="font-Montserrat text-xl font-bold text-black">
            Guide
          </h2>
          <div className="border-b-2 border-blue-200 w-20"></div>
        </div>
        {Status === "Info" ?     <div className="flex font-Montserrat flex-wrap float-left ">
      <div className=" text-blue-200 py-4 font-medium "> Guide{`>`}</div>
      <div className="mt-4 mr-8 ml-2 text-gray-400 font-medium">
        The Name of the Guide
      </div>
    </div>: null}
        {Status === "Step Flow" ?     <div className="flex flex-wrap font-Montserrat float-left ">
      <div className=" text-blue-200 py-4 font-medium "> Guide{`>`}  </div>
      <div className="mt-4 mr-8 ml-2 text-gray-400 font-medium">
        The Guide of Build
      </div>
    </div> : null}
        {Status === "Transaction" ?    <div className="flex font-Montserrat flex-wrap float-left ">
      <div className=" text-blue-200 py-4 font-medium "> Guide{`>`} </div>
      <div className="mt-4 mr-8 ml-2 text-gray-400 font-medium">
        The Name of Guide
      </div>
    </div> : null}
       
        <ToggleDetails />
        {Status === "Info" ? <Guide /> : null}
        {Status === "Step Flow" ? <Stepflow /> : null}
        {Status === "Transaction" ? <Transaction /> : null}
      </div>
    </>
  );
}

export default Dashboard;
